import {
    ElementRef,
    OnInit,
    Input,
    Directive,
    OnChanges,
    SimpleChanges,
    SimpleChange
} from '@angular/core';

@Directive({
    selector: '[checkboxIndeterminate]'
})
export class CheckboxIndeterminateComponent implements OnChanges, OnInit {
    @Input() public checkboxIndeterminate: any;

    constructor(private elem: ElementRef) { }

    ngOnChanges(changes: SimpleChanges): void {
        const checkBoxChange: SimpleChange = changes.checkboxIndeterminate;
        this.elem.nativeElement.indeterminate = checkBoxChange && checkBoxChange.currentValue === true;
    }

    ngOnInit(): void { }
}
